(() => {
  const weekdays = [
    'søndag',
    'mandag',
    'tirsdag',
    'onsdag',
    'torsdag',
    'fredag',
    'lørdag',
  ];
  const months = [
    'januar',
    'februar',
    'marts',
    'april',
    'maj',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'december',
  ];

  const formatDate = (element) => {
    if (element.dataset.saleEndDateFormatted === 'true') return;

    const [year, month, day] = element.dateTime.split('-').map(Number);
    if (!year || !month || !day) return;

    const date = new Date(year, month - 1, day);
    element.textContent = `${weekdays[date.getDay()]} d. ${day}. ${months[month - 1]}`;
    element.dataset.saleEndDateFormatted = 'true';
  };

  const formatDates = (root = document) => {
    root.querySelectorAll('[data-sale-end-date]').forEach(formatDate);
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('[data-sale-end-date]')) formatDate(node);
        formatDates(node);
      });
    });
  });

  const initialize = () => {
    formatDates();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => formatDates(event.target));
})();
